import Component from "../../../lib/component";
import iconHamburgerSvg from './../assets/icon__hamburger.svg';
import iconCloseSvg from './../assets/icon__cross.svg';
export const TogglerConfig = {
    componentTypeKey: 'Toggler',
    baseHtmlClass: 'nav_menu__toggler',
    selector: '.nav_menu__toggler',

    iconSelector: '.nav_menu__toggler__icon',
    closeIconSelector: '.nav_menu__toggler__close_icon',

    defaultIcon: iconHamburgerSvg,
    defaultCloseIcon: iconCloseSvg,
};

export class Toggler extends Component {

    static createToggler(navMenu, toggleImage=null) {
        const element = document.createElement('button');
        element.classList.add(Toggler.config.baseHtmlClass);
        navMenu.element.append(element);
        return new Toggler(element, navMenu);
    }

    static get config() {
        return TogglerConfig;
    }

    constructor(id_or_element, navMenu) {
        super({
            element: id_or_element,
            config: Toggler.config
        });

        this.navMenu = navMenu;
        this.togglerIcon = this.navMenu.element.querySelector(Toggler.config.iconSelector)?.innerHTML ?? Toggler.config.defaultIcon
        this.togglerCloseIcon = this.navMenu.element.querySelector(Toggler.config.closeIconSelector)?.innerHTML ?? Toggler.config.defaultCloseIcon;

        this.element.addEventListener('click', this.handleClick.bind(this));

        // Add a loading modifier for a second to show the loading animation…
        this.addHtmlClassState('loading');
        this.render();
        window.setTimeout(() => {
            this.removeHtmlClassState('loading');
        }, 3000);
    }

    handleClick() {
        this.toggle();
        this.render();
    }

    render() {
        this.element.innerHTML = this.isOpen() ? this.togglerCloseIcon : this.togglerIcon;
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
    }

    toggle() {
        this.navMenu.toggle();
    }

    isOpen() {
        return this.navMenu.isOpen();
    }
}